import React from 'react'
import Image from 'next/image'

import { DefaultHubColors, HubColors, Producer } from '../../interfaces'
import { pickTextColor } from '../../utils/color_helpers'

type Props = {
  producer: Producer
  size?: number
  hubColors?: HubColors,
}

const ProducerAvatar = ({ producer, size = 128, hubColors = DefaultHubColors }: Props) => {
  const producerInitials = producer.name.split(" ").map(namePart => namePart.length ? namePart.substring(0, 1) : "").join("")
  const textOnPrimaryColor = pickTextColor(hubColors.primary, 'white', 'black')

  const avatar = producer.avatar_url ? (
    <div className="rounded-full my-1.5" style={{ width: size, height: size }}>
      <Image className="rounded-full" src={producer.avatar_url} alt={`${producer.name} avatar`} width={size * 2} height={size * 2} objectFit="cover" />
    </div>
  ) : (
    <div data-testid="ProducerAvatar--background" className="rounded-full my-1.5 flex items-center" style={{ width: size, height: size, backgroundColor: hubColors.primary }}>
      <span data-testid="ProducerAvatar--intials" className="text-3xl text-center mx-auto my-auto w-100" style={{ color: textOnPrimaryColor }}>{producerInitials}</span>
    </div>
  );

  return (
    <div className="ProducerAvatar flex flex-col items-center">
      <span style={{ color: hubColors.foreground }}>Listed by</span>
      {avatar}
      <span className="text-2xl" style={{ color: hubColors.foreground }}>{producer.name}</span>
    </div>
  )
}

export default ProducerAvatar
